import { Plugin } from '@ckeditor/ckeditor5-core';
import CaretUp from '../theme/icons/caret-up.svg';
import CaretDown from '../theme/icons/caret.svg';
import { ButtonView } from '@ckeditor/ckeditor5-ui';
import '../theme/css/style.css';

export default class ShowExtended extends Plugin {
	get hideExtendedButton() {
		return {
			label: 'Hide Extended',
			icon: CaretUp,
			tooltip: true,
		};
	}

	get showExtendedButton() {
		return {
			label: 'Show Extended',
			icon: CaretDown,
			tooltip: true,
		};
	}

	get iconStyle() {
		return {
			attributes: {
				style: { width: '10px' },
			},
		};
	}

	init() {
		const editor = this.editor;
		const config = editor.config;
		let expanded = config.get('showextended.expanded');

		editor.ui.componentFactory.add('showExtended', (locale) => {
			const view = new ButtonView(locale);
			let isExtended = expanded;
			view.set(this.hideExtendedButton);
			view.iconView.extendTemplate(this.iconStyle);

			// Callback executed once the image is clicked.
			view.on('execute', () => {
				if (isExtended === false) {
					// switching from isExtended = false to isExtended = true
					view.set(this.hideExtendedButton);
					this._showExtendedToolbar(editor, view);
					isExtended = true;
				} else {
					// switching from isExtended = true to isExtended = false
					view.set(this.showExtendedButton);
					this._hideExtendedToolbar(editor, view);
					isExtended = false;
				}
			});
			editor.once(
				'ready',
				(eventInfo) => {
					if (!expanded) {
						view.set(this.showExtendedButton);
						this._hideExtendedToolbar(this.editor, view);
						isExtended = false;
					} else {
						view.set(this.hideExtendedButton);
						this._showExtendedToolbar(this.editor, view);
						isExtended = true;
					}
				},
				{ priority: 'highest' },
			);

			return view;
		});
	}

	_showExtendedToolbar(editor, view) {
		const length = editor.ui.view.toolbar.items.length;
		for (let i = 0; i < length; i++) {
			const item = editor.ui.view.toolbar.items.get(i);
			if (item.element) {
				item.element.classList.remove('ck-hidden');
			}
		}
	}

	_hideExtendedToolbar(editor, view) {
		let visible = true;
		const length = editor.ui.view.toolbar.items.length;
		for (let i = 0; i < length; i++) {
			const item = editor.ui.view.toolbar.items.get(i);
			if (item.element) {
				if (visible) {
					item.element.classList.remove('ck-hidden');
				} else {
					item.element.classList.add('ck-hidden');
				}
			}
			if (item.viewUid === view.viewUid) {
				visible = false;
			}
		}
	}
}
